import domReady from '@roots/sage/client/dom-ready';
import scroll from '@scripts/modules/scroll';
import tracking from '@scripts/modules/tracking';
import search from '@scripts/modules/search';

/**
 * Application entrypoint
 */
domReady(async () => {
  tracking();
  scroll();
  search();
});

/**
 * @see {@link https://webpack.js.org/api/hot-module-replacement/}
 */
import.meta.webpackHot?.accept(console.error);
